import logo from '../assets/images/beleco_logo_black.png';

export default (event) => {
  // eslint-disable-next-line no-param-reassign
  event.target.src = logo;
};
